<script>
  import PageSectionHeader from "$lib/components/Page/PageSectionHeader.svelte";

  export let data;
</script>

<PageSectionHeader eyebrow={data.fields.eyebrow} headline={data.fields.headline} />
